import {
  AssetCategories,
  AssetTypesLocalized,
  FieldType,
  FilterFormDataModel,
  LufthansaContentOptions,
  LufthansaProductOptions,
  PROMPTS,
  WidthClass,
} from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { BuyoutRightsMakeOS, BuyoutRightsMakeOSSecondLevel, MediaCategories, MediaLists, TerritoryCategories, TerritoryList } from '@thehubz/shared/model';

export class FilterFormData {
  static FORM_DATA: FilterFormDataModel = {
    title: 'Asset',
    description: '',
    customClient: CustomClients.Standard,
    formFields: [
      {
        formTypeId: '3',
        formFieldName: 'client',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Client`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        functionCall: true,
        formGroup: true,
        visible: true,
        options: [],
      },
      {
        formTypeId: '4',
        formFieldName: 'brand',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Brand`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        formGroup: true,
        visible: true,
        options: [],
      },
      {
        formTypeId: '2',
        formFieldName: 'assetType',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Asset type`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        options: AssetTypesLocalized,
      },
      {
        formTypeId: '5',
        formFieldName: 'status',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Status`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        multiple: true,
        options: [],
      },
      {
        formTypeId: '2',
        formFieldName: 'assetCategory',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Asset category`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
        inputType: '',
        multiple: true,
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        options: AssetCategories,
      },
      {
        formTypeId: '23',
        formFieldName: 'relationType',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Relation type`,
        placeholder: $localize`:placeholder:-- All Relation type --`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        visible: false,
        multiple: true,
        options: [],
      },
      {
        formTypeId: '2',
        formFieldName: 'lufthansaContent',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Content`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        functionCall: true,
        visible: false,
        sortDataSource: false,
        options: LufthansaContentOptions,
      },
      {
        formTypeId: '2',
        formFieldName: 'lufthansaProduct',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Product`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        sortDataSource: false,
        visible: false,
        options: LufthansaProductOptions,
      },
      {
        formTypeId: '2',
        formFieldName: 'buyoutRightsTitle',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Buyout rights`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        sortDataSource: false,
        functionCall: true,
        options: BuyoutRightsMakeOS,
        visible: true,
      },
      {
        formTypeId: '4',
        formFieldName: 'buyoutRightsSecondLevelType',
        fieldType: FieldType.Dropdown,
        fieldLabel: 'Update Dynamically',
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        sortDataSource: false,
        value: '',
        disable: false,
        options: BuyoutRightsMakeOSSecondLevel,
        visible: false,
      },
      {
        formTypeId: '1',
        formFieldName: 'territory',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Territory`,
        placeholder: $localize`:placeholder:Territory`,
        widthClass: WidthClass.W12,
        options: [...TerritoryCategories, ...TerritoryList],
        value: '',
        dropDownSearch: true,
        functionCall: true,
        visible: true,
        matDivider: TerritoryCategories.length - 1,
        sortDataSource: false,
        multiple: true,
      },
      {
        formTypeId: '2',
        formFieldName: 'media',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Media`,
        placeholder: $localize`:placeholder:Media`,
        widthClass: WidthClass.W12,
        options: [...MediaCategories, ...MediaLists],
        value: '',
        dropDownSearch: true,
        functionCall: true,
        visible: true,
        matDivider: MediaCategories.length - 1,
        sortDataSource: false,
        multiple: true,
      },
      {
        formTypeId: '16',
        formFieldName: 'expiry-label',
        fieldLabel: $localize`Expiry date`,
        fieldType: FieldType.Label,
        placeholder: '',
        visible: true,
        widthClass: WidthClass.WFull,
      },
      {
        formTypeId: '17',
        formFieldName: 'expiryDate_from',
        fieldType: FieldType.Date,
        fieldLabel: $localize`From`,
        placeholder: $localize`DD/MM/YYYY`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        visible: true,
      },
      {
        formTypeId: '18',
        formFieldName: 'expiryDate_to',
        fieldType: FieldType.Date,
        fieldLabel: $localize`To`,
        placeholder: $localize`DD/MM/YYYY`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        visible: true,
      },
      {
        formTypeId: '13',
        formFieldName: 'date-label',
        fieldLabel: $localize`Date created`,
        fieldType: FieldType.Label,
        placeholder: '',
        visible: true,
        widthClass: WidthClass.WFull,
      },
      {
        formTypeId: '14',
        formFieldName: 'createdDate_from',
        fieldType: FieldType.Date,
        fieldLabel: $localize`From`,
        placeholder: $localize`DD/MM/YYYY`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        visible: true,
      },
      {
        formTypeId: '15',
        formFieldName: 'createdDate_to',
        fieldType: FieldType.Date,
        fieldLabel: $localize`To`,
        placeholder: $localize`DD/MM/YYYY`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        disable: false,
        visible: true,
      },
    ],
  };
}
